import React from 'react';
import { bearerHeaders } from '../api.ts';
import { api, Mark, MarkCostModel, FallAvgift, KottKostnad } from '../api.ts';
import { resolveUrl } from '../api.ts';
import { MarkFastighet } from './MarkFastighet';

interface EkonomiTabProps {
  mark: Mark;
  setMark: (m: Mark) => void;
  costLd: boolean;
  costModel: MarkCostModel | null;
  setCostModel: (v: MarkCostModel | null) => void;
  costSaving: boolean;
  setCostSaving: (v: boolean) => void;
  costErr: string;
  setCostErr: (v: string) => void;
  costForm: {arsavgift:string;viltvardAvgiftPerAr:string;gastKostnadPerJakt:string;medlemKostnadPerJakt:string;boterOlovligtVilt:string;boterEftersok:string};
  setCostForm: React.Dispatch<React.SetStateAction<{arsavgift:string;viltvardAvgiftPerAr:string;gastKostnadPerJakt:string;medlemKostnadPerJakt:string;boterOlovligtVilt:string;boterEftersok:string}>>;
  fallavgifter: FallAvgift[];
  setFallavgifter: React.Dispatch<React.SetStateAction<FallAvgift[]>>;
  kottkostnad: KottKostnad[];
  setKottkostnad: React.Dispatch<React.SetStateAction<KottKostnad[]>>;
  newFall: FallAvgift;
  setNewFall: React.Dispatch<React.SetStateAction<FallAvgift>>;
  newKott: KottKostnad;
  setNewKott: React.Dispatch<React.SetStateAction<KottKostnad>>;
  editMarkInfo: boolean;
  setEditMarkInfo: React.Dispatch<React.SetStateAction<boolean>>;
  markInfoForm: {areaHa:string;municipality:string;county:string;address:string};
  setMarkInfoForm: React.Dispatch<React.SetStateAction<{areaHa:string;municipality:string;county:string;address:string}>>;
  markInfoSaving: boolean;
  setMarkInfoSaving: (v: boolean) => void;
  swishForm: {swishNumber:string;swishAmount:string;ownerType:'person'|'foretag';ownerNumber:string;invoiceEmail:string};
  setSwishForm: React.Dispatch<React.SetStateAction<{swishNumber:string;swishAmount:string;ownerType:'person'|'foretag';ownerNumber:string;invoiceEmail:string}>>;
  swishSaving: boolean;
  setSwishSaving: (v: boolean) => void;
  swishErr: string;
  setSwishErr: (v: string) => void;
  isAdmin?: boolean;
  /** Ägare, jaktledare/vice och admin får ändra markens grundpriser och betalning. */
  canEditPrices?: boolean;
  T: any;
}

export function EkonomiTab({
  mark, setMark,
  costLd, costModel, setCostModel,
  costSaving, setCostSaving, costErr, setCostErr,
  costForm, setCostForm,
  fallavgifter, setFallavgifter,
  kottkostnad, setKottkostnad,
  newFall, setNewFall,
  newKott, setNewKott,
  editMarkInfo, setEditMarkInfo,
  markInfoForm, setMarkInfoForm,
  markInfoSaving, setMarkInfoSaving,
  swishForm, setSwishForm,
  swishSaving, setSwishSaving,
  swishErr, setSwishErr,
  isAdmin, canEditPrices, T,
}: EkonomiTabProps) {
  if (costLd) {
    return <div style={{color:T.textMuted,fontSize:14,padding:'20px 0'}}>Laddar kostnadsmodell...</div>;
  }

  return (
    <div style={{padding:'0 clamp(10px,3vw,28px) 32px'}}>
      {/* ── JSON EXPORT / IMPORT ── */}
      {isAdmin&&(
        <div style={{display:'flex',gap:10,marginBottom:20,alignItems:'center',flexWrap:'wrap'}}>
          <button onClick={()=>{
            const payload={
              exportedAt:new Date().toISOString(),
              markId:mark.id,
              markName:mark.name,
              markinfo:{...markInfoForm},
              grundavgifter:{...costForm},
              fallavgifter,
              kottkostnad,
              betalning:{...swishForm},
            };
            const blob=new Blob([JSON.stringify(payload,null,2)],{type:'application/json'});
            const url=URL.createObjectURL(blob);
            const a=document.createElement('a');
            a.href=url;
            a.download=`ekonomi-${mark.name.replace(/\s+/g,'-')}-${new Date().toISOString().slice(0,10)}.json`;
            a.click();
            URL.revokeObjectURL(url);
          }} style={{background:T.surface,color:T.text,border:`1px solid ${T.border}`,borderRadius:6,padding:'9px 18px',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',gap:7}}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Ladda ner JSON
          </button>
          <label style={{background:T.surface,color:T.text,border:`1px solid ${T.border}`,borderRadius:6,padding:'9px 18px',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',gap:7}}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            Ladda upp JSON
            <input type="file" accept=".json,application/json" style={{display:'none'}} onChange={e=>{
              const file=e.target.files?.[0];if(!file)return;
              const reader=new FileReader();
              reader.onload=ev=>{
                try{
                  const d=JSON.parse(ev.target?.result as string);
                  if(d.markinfo)setMarkInfoForm(p=>({...p,...d.markinfo}));
                  if(d.grundavgifter)setCostForm(p=>({...p,...d.grundavgifter}));
                  if(Array.isArray(d.fallavgifter))setFallavgifter(d.fallavgifter);
                  if(Array.isArray(d.kottkostnad))setKottkostnad(d.kottkostnad);
                  if(d.betalning)setSwishForm(p=>({...p,...d.betalning}));
                  alert('JSON importerad! Granska värdena och spara varje sektion separat.');
                }catch{alert('Ogiltig JSON-fil.');}
              };
              reader.readAsText(file);
              e.target.value='';
            }}/>
          </label>
          <span style={{color:T.textMuted,fontSize:12}}>Exportera/importera all ekonomidata som JSON</span>
        </div>
      )}

      {/* Mark info (hektar, kommun) */}
      <div style={{background:T.surface,borderRadius:8,padding:20,marginBottom:24,border:`1px solid ${T.border}`}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
          <div style={{color:T.text,fontSize:16,fontWeight:700}}>Markinfo</div>
          {isAdmin&&<button onClick={()=>setEditMarkInfo(p=>!p)} style={{background:editMarkInfo?T.surface:T.amber,color:editMarkInfo?T.text:'#000',border:editMarkInfo?`1px solid ${T.border}`:'none',borderRadius:5,padding:'6px 16px',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'inherit'}}>{editMarkInfo?'Avbryt':'Redigera'}</button>}
        </div>
        {!editMarkInfo?(
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:12}}>
            {[['Areal',mark.areaHa?`${mark.areaHa} ha`:'—'],['Kommun',mark.municipality||'—'],['Län',mark.county||'—'],['Adress',mark.address||'—']].map(([l,v])=>(
              <div key={l} style={{background:T.bg,borderRadius:6,padding:'10px 14px'}}>
                <div style={{color:T.textMuted,fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:1,marginBottom:4}}>{l}</div>
                <div style={{color:T.text,fontSize:14,fontWeight:600}}>{v}</div>
              </div>
            ))}
          </div>
        ):(
          <div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
              {[['Areal (ha)','areaHa'],['Kommun','municipality'],['Län','county'],['Adress','address']].map(([l,k])=>(
                <label key={k} style={{display:'flex',flexDirection:'column',gap:4}}>
                  <span style={{color:T.textMuted,fontSize:12,fontWeight:600}}>{l}</span>
                  <input value={(markInfoForm as Record<string,string>)[k]} onChange={e=>setMarkInfoForm(p=>({...p,[k]:e.target.value}))} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:5,padding:'8px 12px',color:T.text,fontSize:14,fontFamily:'inherit'}}/>
                </label>
              ))}
            </div>
            <button disabled={markInfoSaving} onClick={async()=>{setMarkInfoSaving(true);try{const updated=await api.updateMark(mark.id,{areaHa:markInfoForm.areaHa?parseFloat(markInfoForm.areaHa):undefined,municipality:markInfoForm.municipality||undefined,county:markInfoForm.county||undefined,address:markInfoForm.address||undefined});setMark(updated);setEditMarkInfo(false);}catch(e:unknown){alert(e instanceof Error?e.message:'Fel');}finally{setMarkInfoSaving(false);}}} style={{background:T.amber,color:'#000',border:'none',borderRadius:5,padding:'8px 20px',fontSize:14,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>{markInfoSaving?'Sparar...':'Spara markinfo'}</button>
          </div>
        )}
        <MarkFastighet mark={mark} canEdit={!!canEditPrices} onMarkChanged={patch=>setMark({...mark,...patch})}/>
      </div>

      {/* Kostnadsmodell */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14,flexWrap:'wrap',gap:8}}>
        <div style={{color:T.text,fontSize:16,fontWeight:700}}>Kostnadsmodell</div>
        {isAdmin&&<div style={{display:'flex',gap:8}}>
          <button onClick={()=>{
            const data={
              markInfo:{areaHa:mark.areaHa,municipality:mark.municipality,county:mark.county,address:mark.address},
              grundavgifter:{arsavgift:Number(costForm.arsavgift)||0,viltvardAvgiftPerAr:Number(costForm.viltvardAvgiftPerAr)||0,gastKostnadPerJakt:Number(costForm.gastKostnadPerJakt)||0,medlemKostnadPerJakt:Number(costForm.medlemKostnadPerJakt)||0,boterOlovligtVilt:Number(costForm.boterOlovligtVilt)||0,boterEftersok:Number(costForm.boterEftersok)||0},
              fallavgifter,
              kottkostnad,
              swish:{swishNumber:swishForm.swishNumber,swishAmount:Number(swishForm.swishAmount)||0,ownerType:swishForm.ownerType,ownerNumber:swishForm.ownerNumber,invoiceEmail:swishForm.invoiceEmail},
              exportDate:new Date().toISOString(),
              markName:mark.name,
            };
            const blob=new Blob([JSON.stringify(data,null,2)],{type:'application/json'});
            const url=URL.createObjectURL(blob);
            const a=document.createElement('a');a.href=url;a.download=`ekonomi-${mark.name.replace(/[^a-zåäö0-9]/gi,'_').toLowerCase()}-${new Date().toISOString().slice(0,10)}.json`;
            document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
          }} style={{background:T.surface,color:T.text,border:`1px solid ${T.border}`,borderRadius:5,padding:'6px 14px',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'inherit'}}>Exportera JSON</button>
          <button onClick={()=>{
            const inp=document.createElement('input');inp.type='file';inp.accept='.json';inp.style.display='none';
            document.body.appendChild(inp);
            inp.addEventListener('change',()=>{
              if(!inp.files?.length){document.body.removeChild(inp);return;}
              const reader=new FileReader();
              reader.onload=(ev)=>{
                try{
                  const d=JSON.parse(ev.target?.result as string);
                  if(d.grundavgifter){setCostForm({arsavgift:String(d.grundavgifter.arsavgift||0),viltvardAvgiftPerAr:String(d.grundavgifter.viltvardAvgiftPerAr||0),gastKostnadPerJakt:String(d.grundavgifter.gastKostnadPerJakt||0),medlemKostnadPerJakt:String(d.grundavgifter.medlemKostnadPerJakt||0),boterOlovligtVilt:String(d.grundavgifter.boterOlovligtVilt||0),boterEftersok:String(d.grundavgifter.boterEftersok||0)});}
                  if(Array.isArray(d.fallavgifter))setFallavgifter(d.fallavgifter);
                  if(Array.isArray(d.kottkostnad))setKottkostnad(d.kottkostnad);
                  if(d.swish){setSwishForm({swishNumber:d.swish.swishNumber||'',swishAmount:String(d.swish.swishAmount||0),ownerType:(d.swish.ownerType||'person') as 'person'|'foretag',ownerNumber:d.swish.ownerNumber||'',invoiceEmail:d.swish.invoiceEmail||''});}
                  if(d.markInfo){setMarkInfoForm({areaHa:String(d.markInfo.areaHa||''),municipality:d.markInfo.municipality||'',county:d.markInfo.county||'',address:d.markInfo.address||''});}
                  setCostErr('');
                  alert('Ekonomidata importerad! Tryck Spara för att bekräfta.');
                }catch(_){alert('Ogiltig JSON-fil');}
                document.body.removeChild(inp);
              };
              reader.readAsText(inp.files[0]);
            });
            inp.click();
          }} style={{background:T.surface,color:T.text,border:`1px solid ${T.border}`,borderRadius:5,padding:'6px 14px',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'inherit'}}>Importera JSON</button>
        </div>}
      </div>
      {costErr&&<div style={{color:'#ff6b6b',background:'rgba(255,100,100,0.1)',borderRadius:5,padding:'8px 12px',marginBottom:12,fontSize:13}}>{costErr}</div>}

      {/* Grundavgifter */}
      <div style={{background:T.surface,borderRadius:8,padding:20,marginBottom:16,border:`1px solid ${T.border}`}}>
        <div style={{color:T.textMuted,fontSize:12,fontWeight:700,textTransform:'uppercase',letterSpacing:1,marginBottom:14}}>Grundpriser – gäller grupper utan egna priser</div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:12}}>
          {[['Årsavgift (kr/år)','arsavgift'],['Viltvårdsavgift (kr/år)','viltvardAvgiftPerAr'],['Gästkostnad per jakt (kr)','gastKostnadPerJakt'],['Medlemskostnad per jakt (kr)','medlemKostnadPerJakt'],['Böter olovligt vilt (kr)','boterOlovligtVilt'],['Böter eftersök (kr)','boterEftersok']].map(([l,k])=>(
            <label key={k} style={{display:'flex',flexDirection:'column',gap:4}}>
              <span style={{color:T.textMuted,fontSize:12,fontWeight:600}}>{l}</span>
              {canEditPrices?(
                <input type="number" min="0" value={(costForm as Record<string,string>)[k]} onChange={e=>setCostForm(p=>({...p,[k]:e.target.value}))} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:5,padding:'8px 12px',color:T.text,fontSize:14,fontFamily:'inherit',width:'100%',boxSizing:'border-box'}}/>
              ):(
                <div style={{color:T.text,fontSize:15,fontWeight:700,padding:'8px 0'}}>{Number((costForm as Record<string,string>)[k]||0).toLocaleString('sv-SE')} kr</div>
              )}
            </label>
          ))}
        </div>
      </div>

      {canEditPrices&&(
        <button disabled={costSaving} onClick={async()=>{
          setCostSaving(true);setCostErr('');
          try{
            const saved=await api.upsertMarkCostModel(mark.id,{
              arsavgift:Number(costForm.arsavgift)||0,
              viltvardAvgiftPerAr:Number(costForm.viltvardAvgiftPerAr)||0,
              gastKostnadPerJakt:Number(costForm.gastKostnadPerJakt)||0,
              medlemKostnadPerJakt:Number(costForm.medlemKostnadPerJakt)||0,
              fallavgifter,kottkostnad,
              kottIngar:costModel?.kottIngar??false,
              antalDrevjakter:costModel?.antalDrevjakter??0,
              kanBokaKalendar:costModel?.kanBokaKalendar??false,
              boterOlovligtVilt:Number(costForm.boterOlovligtVilt)||0,
              boterEftersok:Number(costForm.boterEftersok)||0,
            });
            setCostModel(saved);
          }catch(e:unknown){setCostErr(e instanceof Error?e.message:'Något gick fel');}
          finally{setCostSaving(false);}
        }} style={{background:T.amber,color:'#000',border:'none',borderRadius:6,padding:'12px 28px',fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'inherit',width:'100%'}}>{costSaving?'Sparar...':'Spara kostnadsmodell'}</button>
      )}

      {/* ── SWISH & ÄGARINFO ── */}
      <div style={{marginTop:32}}>
        <div style={{color:T.text,fontSize:16,fontWeight:700,marginBottom:14}}>Betalning & Ägarinformation</div>
        {swishErr&&<div style={{color:'#ff6b6b',background:'rgba(255,100,100,0.1)',borderRadius:5,padding:'8px 12px',marginBottom:12,fontSize:13}}>{swishErr}</div>}
        <div style={{background:T.surface,borderRadius:8,padding:20,marginBottom:16,border:`1px solid ${T.border}`}}>
          {/* Ägartyp */}
          <div style={{marginBottom:16}}>
            <div style={{color:T.textMuted,fontSize:12,fontWeight:700,textTransform:'uppercase',letterSpacing:1,marginBottom:10}}>Ägare av jakträtten</div>
            <div style={{display:'flex',gap:10,marginBottom:14}}>
              {(['person','foretag'] as const).map(ot=>(
                <button key={ot} onClick={()=>{if(canEditPrices)setSwishForm(p=>({...p,ownerType:ot}))}}
                  style={{flex:1,background:swishForm.ownerType===ot?T.amber:T.bg,color:swishForm.ownerType===ot?'#000':T.textMuted,border:`1px solid ${swishForm.ownerType===ot?T.amber:T.border}`,borderRadius:6,padding:'10px 0',fontSize:14,fontWeight:700,cursor:canEditPrices?'pointer':'default',fontFamily:'inherit'}}>
                  {ot==='person'?'Person':'Företag'}
                </button>
              ))}
            </div>
            {canEditPrices?(
              <div>
                <div style={{color:T.textMuted,fontSize:12,fontWeight:600,marginBottom:4}}>{swishForm.ownerType==='person'?'Personnummer (YYYYMMDD-XXXX)':'Organisationsnummer (XXXXXX-XXXX)'}</div>
                <input value={swishForm.ownerNumber} onChange={e=>setSwishForm(p=>({...p,ownerNumber:e.target.value}))} placeholder={swishForm.ownerType==='person'?'19800101-1234':'556000-1234'} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:5,padding:'8px 12px',color:T.text,fontSize:14,fontFamily:'inherit',width:'100%',boxSizing:'border-box'}}/>
              </div>
            ):(
              <div style={{color:T.text,fontSize:14,padding:'8px 0'}}>{swishForm.ownerNumber||'—'}</div>
            )}
          </div>
          {/* Swish */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
            {[['Swish-nummer för utbetalning','swishNumber','text','123 456 78 90'],['Belopp (kr)','swishAmount','number','0']].map(([l,k,tp,ph])=>(
              <label key={k} style={{display:'flex',flexDirection:'column',gap:4}}>
                <span style={{color:T.textMuted,fontSize:12,fontWeight:600}}>{l}</span>
                {canEditPrices?(
                  <input type={tp} value={(swishForm as Record<string,string>)[k]} onChange={e=>setSwishForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:5,padding:'8px 12px',color:T.text,fontSize:14,fontFamily:'inherit',width:'100%',boxSizing:'border-box'}}/>
                ):(
                  <div style={{color:T.text,fontSize:15,fontWeight:700,padding:'8px 0'}}>{k==='swishAmount'?Number(swishForm.swishAmount||0).toLocaleString('sv-SE')+' kr':swishForm.swishNumber||'—'}</div>
                )}
              </label>
            ))}
          </div>
          {/* Faktura-epost */}
          <div>
            <div style={{color:T.textMuted,fontSize:12,fontWeight:700,textTransform:'uppercase',letterSpacing:1,marginBottom:6}}>E-post för fakturaunderlag</div>
            {canEditPrices?(
              <input type="email" value={swishForm.invoiceEmail} onChange={e=>setSwishForm(p=>({...p,invoiceEmail:e.target.value}))} placeholder="faktura@exempel.se" style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:5,padding:'8px 12px',color:T.text,fontSize:14,fontFamily:'inherit',width:'100%',boxSizing:'border-box'}}/>
            ):(
              <div style={{color:T.text,fontSize:14,padding:'6px 0'}}>{swishForm.invoiceEmail||'—'}</div>
            )}
            <div style={{color:T.textMuted,fontSize:11,marginTop:4}}>Fakturaunderlag för föregående månads försäljning skickas hit i början av månaden. Betalas inom 30 dagar.</div>
          </div>
        </div>
        {canEditPrices&&(
          <button disabled={swishSaving} onClick={async()=>{
            setSwishSaving(true);setSwishErr('');
            try{
              const headers:Record<string,string>={'Content-Type':'application/json','X-Api-Key':'dev-secret'};
              const t=localStorage.getItem('qvenari_access_token');if(t)Object.assign(headers,bearerHeaders(t));
              const res=await fetch(resolveUrl('/graphql'),{method:'POST',headers,body:JSON.stringify({query:`mutation UMS($markId:ID!,$swish:String!,$amount:Float!,$ownerType:String,$ownerNumber:String,$invoiceEmail:String){updateMarkSwish(markId:$markId,swishNumber:$swish,swishAmount:$amount,ownerType:$ownerType,ownerNumber:$ownerNumber,invoiceEmail:$invoiceEmail)}`,variables:{markId:mark.id,swish:swishForm.swishNumber,amount:Number(swishForm.swishAmount)||0,ownerType:swishForm.ownerType,ownerNumber:swishForm.ownerNumber||null,invoiceEmail:swishForm.invoiceEmail||null}})});
              const d=await res.json();
              if(d.errors?.length)throw new Error(d.errors[0].message);
            }catch(e:unknown){setSwishErr(e instanceof Error?e.message:'Något gick fel');}
            finally{setSwishSaving(false);}
          }} style={{background:T.amber,color:'#000',border:'none',borderRadius:6,padding:'12px 28px',fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'inherit',width:'100%'}}>{swishSaving?'Sparar...':'Spara betalningsinställningar'}</button>
        )}
      </div>
    </div>
  );
}
